import routes from '@/routes';

export const DEFAULT_REDIRECT_ROUTE = routes.myDocuments;
